import React, {useState} from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box} from "@mui/material";
import Slide from '@mui/material/Slide';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { postRequest } from '../../utils/NetworkHandler';

const Transition = React.forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);


export default function RejectDialog(props) {
    const [maxWidth, setMaxWidth] = React.useState('xs');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [loading, setLoading] = useState(false);

  
    const {teachers} = props;
    const {studentId} = props;
    const [comment, setcomment] = useState(" ");
  

    const saveAccount = () => {
        setLoading(true);
        let formValidated = true;
        

        if(comment === " "){
          formValidated = false;
          alert("Please enter a comment");
        }
       

        if(formValidated){
            const data = {'student_id': studentId, "comment": comment}
            postRequest("/landing/api/ummah/reject", data, onSuccess, onError, true);
        }
        else{
            setLoading(false);
        }

    }

    const onSuccess = (response)=> {
        setLoading(false);

        const {data} = response;
        if(data.status){
           
          setcomment("");
            handleClose();
            props.onRefresh();
        }
    }

    const onError = (error) => {
        setLoading(false);
        alert(error.toString());
    }

    const handleClose = () => {
        
        props.handleClose();

    }

    const handleTeacherChange = (e) => {
      setcomment(e.target.value);
    }
    

  return (
    <div>
      
      <Dialog open={props.open} onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
        TransitionComponent={Transition}
      >
        <DialogTitle>Reject</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{mb:2}}>
          Please enter the resone for rejection
          </DialogContentText>
          <TextField 
         
          fullWidth
            autoFocus
            margin="dense"
            id="addresss"
            label="Comment"
            type="text"
            multiline
          rows={2}

            onChange={(e) => setcomment(e.target.value)}
            variant="outlined"
          />


         {/* <FormControl
      sx={{mt:2}}
      fullWidth>
        <InputLabel id="assign-to-teacher">Teacher</InputLabel>
        <Select
          labelId="assign-to-teacher"
          id="assign-to-teacher-select"
          value={comment}
          label="Assign To"
          onChange={handleTeacherChange}
        >
          <MenuItem value={"-1"}>Select a teacher</MenuItem>
          {teachers.map(( item, index) => (
          <MenuItem
          key={index}
          value={item.id}> {item.username}</MenuItem>
          ) )}
        </Select>
      </FormControl> */}


        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={loading}  onClick={() => saveAccount() }>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


